import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/integrations/tanstack-query/query-client";
import { pointTransactionKeys } from "./query";
import { type CreateTransactionParams, createTransaction } from "./services";

export function useCreateTransactionMutation() {
  return useMutation({
    mutationFn: (params: CreateTransactionParams) => createTransaction(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: pointTransactionKeys.all });
    },
  });
}
